import { render, staticRenderFns } from "./TabIntro.vue?vue&type=template&id=39b22068&scoped=true"
import script from "./TabIntro.vue?vue&type=script&lang=js"
export * from "./TabIntro.vue?vue&type=script&lang=js"
import style0 from "./TabIntro.vue?vue&type=style&index=0&id=39b22068&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b22068",
  null
  
)

export default component.exports